export const durations = {
  ultraFast: 80,
  fast: 200,
  normal: 280,
  slow: 800,
  routeTransition: 240
};
